export default class AccordionConfig{

  public constructor(
    public allowMultipleExpanded: boolean = false,
    public sections: string[] = ['Section 1']
  ){}
}
